import { useMemo } from "react";

import { Schema } from "src/api/flowTypes";
import { AgentVersion } from "src/clients/agent-management";
import { SchemaOptions } from "src/router/SearchParams";
import { SchemaConverter, SchemaUI } from "src/schema/schemaMappingUtils";

type AgentSchemas = {
  input: SchemaUI | undefined;
  output: SchemaUI | undefined;
};

export const buildAgentUiSchemas = (
  configuration: AgentVersion["configuration"] | undefined,
): AgentSchemas => ({
  input:
    configuration?.input_schema &&
    Object.keys(configuration.input_schema).length !== 0
      ? SchemaConverter.beToUI(
          configuration.input_schema as Schema,
          SchemaOptions.Input,
        )
      : undefined,
  output:
    configuration?.output_schema &&
    Object.keys(configuration.output_schema).length !== 0
      ? SchemaConverter.beToUI(
          configuration.output_schema as Schema,
          SchemaOptions.Output,
        )
      : undefined,
});

export const useAgentSchemas = (
  version: AgentVersion | undefined,
): AgentSchemas => {
  return useMemo(
    () => buildAgentUiSchemas(version?.configuration),
    // Only depend on the schema fields to avoid unnecessary recalculations
    [
      version?.configuration?.input_schema,
      version?.configuration?.output_schema,
    ],
  );
};
